export default function CTASection() {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://readdy.ai/api/search-image?query=elegant%20restaurant%20interior%20with%20warm%20ambient%20lighting%20cozy%20dining%20atmosphere%20with%20wooden%20tables%20and%20comfortable%20seating%20soft%20golden%20lights%20creating%20inviting%20ambiance%20blurred%20background%20showing%20happy%20diners%20enjoying%20meals%20welcoming%20hospitality%20scene&width=1920&height=600&seq=cta-bg-image&orientation=landscape" 
          alt="Restaurant Atmosphere" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <h2 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6">
          Come Visit Us Today
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Experience fresh flavors and warm hospitality
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a 
            href="tel:+15551234567"
            className="px-8 py-4 bg-red-700 text-white rounded-full font-semibold hover:bg-red-800 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
            style={{ minWidth: '200px', justifyContent: 'center' }}
          >
            <i className="ri-phone-line"></i>
            Call Now
          </a>
          <a 
            href="#location"
            className="px-8 py-4 bg-white text-gray-900 rounded-full font-semibold hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
            style={{ minWidth: '200px', justifyContent: 'center' }}
          >
            <i className="ri-map-pin-line"></i>
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
}